import React from "react"
import cx from "classnames"

const LayoutSectionTitle = ({
  children,
  headerLink,
}: {
  children: string
  headerLink?: React.ReactNode
}) => {
  return (
    <h2
      className={cx("cobalt-layout-section-title", {
        "cobalt-layout--hasHeaderLink": !!headerLink,
      })}
    >
      {headerLink && (
        <div className="cobalt-layout-header-link">{headerLink}</div>
      )}
      {children}
    </h2>
  )
}

export default LayoutSectionTitle
